<template>
	<Overlay
		title="Nieuwe gebruiksvoorwaarden"
		ref="overlay"
		class="overlay--gdprTerms"
		:root="true"
		:isShown="true"
		@beforehide="onBeforeHide"
		@denyTerms="onDenyTerms"
	>
		<!-- <template #beforeBody> -->
		<!-- </template> -->
			<template #body>
				<slot name="body">
					<div class="body-wrapper">
					<p>De gebruiksvoorwaarden van “Mijn Mooie Straat” beschrijven de regels rond o.a. het gebruiksrecht, intellectueel eigendomsrecht en databeheer van dit digitaal platform. Lees deze gebruiksvoorwaarden zorgvuldig door, aangezien deze van toepassing zijn op jouw gebruik.</p>
					<p class="intro">Je dient de gebruiksvoorwaarden volledig te lezen alvorens je ze kan aanvaarden of weigeren.</p>
					<div class="inner-scroll" @scroll="onScroll">
						<Loader :nested="true" ref="termsLoader" :isShown="isLoading"/>

						<div class="scroll-text" ref="scrollText" v-html="termsOfUse.text">
						</div>
						<a :href="termsOfUse.pdf" target="_blank" class="button button--light button--shakespeare button--hasIconBefore button--hasDownloadIcon">
							<span class="color--shakespeare">Download als .pdf</span>
						</a>
					</div>

					<FormKit type="form" :actions="false" id="formGdprTerms" ref="formGdprTerms">
						<FormKit
							type="checkbox"
							label="Ik aanvaard de gebruiksvoorwaarden."
							v-model="approved"
						/>
					</FormKit>
				</div>
				</slot>
			</template>
			<template #footer>
				<div class="overlay-footerContent">
						<div class="footer-actions-group">
						<button
							class="button button--light button--carnation button--hasIconBefore button--hasCrossIcon"
							@click="onDenyTerms"
						>
							Weigeren
						</button>
						<button
							:disabled="!approved"
							class="button button button--filled button--big"
							@click="updateGdprTerms"
						>
							{{ buttonText }}
						</button>
					</div>
				</div>
			</template>

	</Overlay>


</template>

<script src="./GdprTermsOverlay.js"></script>
